// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';

// Material UI ( mui ) components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Chip from '@mui/material/Chip';

// Section for import custom components --------------------------------------------------------------------------------
import ContentImage from '@components/common/ContentImage';

// Section for render component ----------------------------------------------------------------------------------------
export default function SPMansionCard(props: any) {
  const { data } = props;
  return (
    <Box className="group relative w-full">
      <Link underline="none" href={`/karte/mansions/detail/${data.mansion_id}/`} variant="body1">
        <Box className="flex justify-between mt-3 pl-5">
          <Box className="mr-4 text-rf-blue font-bold">{data.mansion_name}</Box>
          {data.com_estate_count >= 1 && (
            <Chip
              label="売出し中"
              sx={{
                marginTop: '1px',
                borderRadius: '2px 0px 0px 2px',
                backgroundColor: '#00375F',
                color: '#fff',
                height: '22px',
                lineHeight: '22px',
                paddingY: '0px',
                fontWeight: 'bold',
              }}
            />
          )}
        </Box>
        <Box className="flex justify-between mt-3 px-5 pb-3">
          <Box sx={{ flex: 1, maxWidth: '30%' }}>
            <ContentImage
              src={data.mansion_thumbnail_image_url}
              alt={data.mansion_name}
              className="aspect-video object-cover group-hover:opacity-60"
            />
          </Box>
          <Box className="flex flex-1 flex-col justify-center gap-y-1 max-w-[70%] ml-4">
            <Typography variant="body2" className="max-md:text-sm text-rf-black">
              {data.address_display}
            </Typography>
            <Typography variant="body2" className="max-md:text-sm text-rf-black">
              {data.transit_display}
            </Typography>
            <Typography variant="body2" className="max-md:text-sm text-rf-black">
              築年月：{data.build_created_date_display}
            </Typography>
          </Box>
        </Box>
      </Link>
    </Box>
  );
}
